let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3G0lM")).then(() => parcelRequire('daJGb'));